import { canUseDOM } from 'exenv';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import set from 'lodash/set';
import find from 'lodash/find';
import toNumber from 'lodash/toNumber';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import Insert from '../../../components/post/content/insert';
import throttle from 'lodash/throttle';
import Cookies from 'js-cookie';
import Ad from '../../../components/ad/ad';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import { isAdvertorial } from '../../../../views/components/advertorial/advertorial';
import PostsContainer from '../../../components/post/container';
import MoreStories from '../../../components/more-stories-component/more-stories-component';
import VideoModule from '../../../components/video_module/video_module';
import ToasterVideoModule from '../../../components/toaster_video_module/toaster_video_module';
import FloatingPlayer from '../../../components/floating_player/floating_player';
import EditorHighlights from '../../../components/editor_highlights/editor_highlights';
import highlightShare from 'highlight-share';
import * as twitterSharer from 'highlight-share/dist/sharers/twitter';
import * as facebookSharer from 'highlight-share/dist/sharers/facebook';
import EventModel from '../../../../utils/tracking/models';
import withTracking from '../../../../utils/tracking/components/withTracking';
import { defaultEvent } from '../../../../utils/tracking/events/pageEvents';

import Dianomi from '../../../components/dianomi/dianomi_script';

import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import trackThirdPartyJS from '../../../../client/utils/third_party_trackers/trackThirdPartyJS';
import adsConfig from '../../../../config/ads';
import { buildPostAdModel } from '../../../../utils/ad_util';
import matchMediaDesktop from '../../../../utils/client_util';
import { findAdvertorialTagID } from '../../../../utils/advertorial_utils';
import { infiniteScrollUrlChange } from '../../../../redux/action_creators/post/postpage_action_creators';
import asyncPostFiniteActions from '../../../../redux/actions/post/async_post_finite_actions';
import asyncPostNativeAdActions from '../../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../../redux/action_creators/ads_action_creator';
import { isCategory } from '../../../../utils/category_util';

import generateVideoCustomParams from '../../../../utils/seo_utils/video/video_post_custom_params_util';

import axios from 'axios';

let scriptjs = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
}

class PostPage extends Component {
  constructor(props) {
    super(props);
    const { live } = props.post;

    this.finiteScrollDepth = null;
    this.calledNativePixel = false;
    this.renderedNativeInfiniteScrollPost = false;
    this.setScrollEvents = throttle(() => {
      const { scrollY, innerHeight } = this.window;
      this.setFiniteScrollDepth(scrollY, innerHeight);
      this.setInviewPostUrl(scrollY, innerHeight);
    }, 100);
    this.generateAdData = this.generateAdData.bind(this);
    this.state = {
      finitePosts: [],
      stickToasterVideo: false,
      ignoreToasterVideo: false,
      displayingAdhesiveUnit: false,
      activeInserts: {},
      nativeInfiniteScrollData: {}
    };
    this.playerScriptIds = [
      'QV73eWiB',
      '4h5SWQPt',
      'Pafg29um',
      '27mBLzWL',
      'i70nsZ8K',
      'Lrp0YsKC',
      'wGNMZweZ',
      'kMmGs8qw',
      'WXJihrBk',
      'iqio3VCM',
      'OolwHeKf',
      'FsIzKJce',
      'r04h3Jdn',
      'RvGXj7in',
      'flarUGPa',
      'HzdTLaau',
      'gAy6i1bi',
      'RqEFED7X',
      'vp2iCnvh',
      'b2BPV4nc'
    ];

    this.live = get(live, 'enabled', false) && !!get(live, 'posts.length', 0);

    // this is a hack to prevent infinite scroll for Citrix articles with Knotch tags.
    // if (props.post.id === 90336234 || props.post.id === 90331516) {
    //  this.noscroll = true;
    // } else {
    this.noscroll = false;
    // }
    this.checkAdblock = this.checkAdblock.bind(this);
    this.loadPostFinite = this.loadPostFinite.bind(this);
  }

  componentDidMount() {
    const { statusCode, post } = this.props;
    const postCategories = get(post, 'categories', false);

    this.window = window;
    this.windowWidth = this.window.innerWidth;
    // console.log('windowWidth', this.windowWidth);
    this.body = document.body;
    this.activePost = get(post, 'id') || get(this.props, 'match.params.id');
    this.lazyThresholdFromBottom = 400;
    this.stickySidebar = matchMediaDesktop();
    this.trackedPosts = [];

    if (get(this.props.config, 'featureFlags.textToShare')) {
      this.selectionShare = highlightShare({
        selector: '.post__body',
        sharers: [facebookSharer, twitterSharer],
        onOpen: element => {
          element.setAttribute('id', `user_highlight--${this.activePost}`);

          const event = new EventModel(
            'Highlight Share',
            'articleFormat',
            'hovered',
            'exposed',
            this.getPercentIntoPost(element)
          );
          this.props.trackEvent(event.getTrackingObject());
        }
      });
      this.selectionShare.init();
    }

    this.setActiveSocial();
    this.refreshSocialEmbeds();
    setTimeout(this.checkAdblock, 2000);

    if (this.windowWidth < 768) {
      // console.log('should set adhesive');
      if (
        this.props.post &&
        this.props.post.customFields &&
        this.props.post.customFields.is_list
      ) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ displayingAdhesiveUnit: false });
      } else {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ displayingAdhesiveUnit: true });
      }
    } else {
      // console.log('SHOULD NOT SET ADVESIVE')
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ displayingAdhesiveUnit: false });
    }

    if (!this.live) {
      this.window.addEventListener('scroll', this.setScrollEvents);
    }
    if (
      statusCode !== 404 &&
      statusCode !== 403 &&
      statusCode !== 500 &&
      postCategories
    ) {
      this.loadPostFinite();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isAdvertorial(get(nextProps, 'post.tags'))) {
      return;
    }

    // Check to see if the ad call has been made for mid article injection unit
    const nativeAdMidArticleInjectLoaded = get(
      nextProps,
      'adsLoaded.native_mid_article_inject'
    );

    // Check to see if the ad call has been made for dianomi/sponsor tile unit
    const nativeAdSponsorTileLoaded = get(
      nextProps,
      'adsLoaded.native_sponsoredtile'
    );

    // Check to see if the ad call has been made for recommendation unit
    const nativeAdRecommendationLoaded = get(
      nextProps,
      'adsLoaded.native_recommendationlink'
    );

    // Check to see if the ad call has been made for inf scroll injection unit
    const nativeAdInfiniteScrollLoaded = get(
      nextProps,
      'adsLoaded.native_infinitescroll'
    );

    // Logic, when adcall is made, call out func to fetch posts for that, then set adcalled to false so it doesn't create inf loop
    if (nativeAdMidArticleInjectLoaded) {
      // console.log('midArticleInject Loaded')
      this.getNative('nativeMidArticleInject');
      this.props.dispatchAdLoadedEvent('native_mid_article_inject', false);
    }

    if (nativeAdRecommendationLoaded) {
      this.getNative('nativeAdRecommendation');
      this.props.dispatchAdLoadedEvent('native_recommendationlink', false);
    }

    if (nativeAdSponsorTileLoaded) {
      this.getNative('nativeAdSponsorTile');
      this.props.dispatchAdLoadedEvent('native_sponsoredtile', false);
    }

    if (nativeAdInfiniteScrollLoaded) {
      setTimeout(() => {
        this.getNative('nativeAdInfiniteScroll');
        this.getInfiniteScrollAd('nativeAdInfiniteScroll');
        this.props.dispatchAdLoadedEvent('native_infinitescroll', false);
      }, 0);
    }
  }

  // componentWillUpdate({ post, postData }) {
  //   if (post && post.id !== this.activePost) {
  //     this.activePost = post.id;
  //   }
  // }

  componentDidUpdate(prevProps) {
    const live = get(this.props, 'post.live');
    this.live = get(live, 'enabled', false) && !!get(live, 'posts.length', 0);
    this.refreshSocialEmbeds();
    this.posts = this.getPostElements();
    const prevPropsCategories = get(prevProps, 'post.categories', false);
    const currPropsCategeroies = get(this.props, 'post.categories', false);

    if (
      prevPropsCategories !== currPropsCategeroies &&
      prevPropsCategories === false
    ) {
      this.loadPostFinite();
    }
  }

  componentWillUnmount() {
    if (!this.live) {
      this.window.removeEventListener('scroll', this.setScrollEvents);
    }
    if (get(this.props.config, 'featureFlags.textToShare')) {
      this.selectionShare.destroy();
    }
  }

  getPostElements() {
    return document.querySelectorAll('.post__body');
  }

  getPercentIntoPost(element) {
    const post = document.querySelector(`#post__wrapper-${this.activePost}`);
    const { top = 0, height = 0 } = post.getBoundingClientRect() || {};
    const postHeight = height - top;
    const highlightPosition = parseInt(element.style.top || 0, 10) - top;
    const percent = highlightPosition / postHeight * 100;
    return percent;
  }

  setActiveSocial(post) {
    const activeClass = 'social--active';
    const activeSocial = document.querySelector(`.${activeClass}`);

    if (activeSocial) {
      activeSocial.classList.remove(activeClass);
    }

    const activePost = post || document.querySelector('.post__wrapper');
    if (activePost && activePost.querySelector('.social')) {
      activePost.querySelector('.social').classList.add(activeClass);
    }
  }

  setFiniteScrollDepth(windowPosition, screenHeight) {
    const { postFinite, config, post } = this.props;
    const RECIRC_OFFSET = 300;
    const bottomOfScreen = windowPosition + screenHeight;
    const recircPosition = document.querySelector('.recirc').offsetTop;
    const triggerPoint = recircPosition - RECIRC_OFFSET;

    // Trigger toaster video
    if (
      get(config, 'featureFlags.toasterVideo') &&
      bottomOfScreen >= 1000 &&
      !this.state.ignoreToasterVideo
    ) {
      this.setState({
        stickToasterVideo: true
      });
    }
    if (triggerPoint < bottomOfScreen && get(postFinite, 'length')) {
      if (
        !this.renderedNativeInfiniteScrollPost &&
        get(this.props, 'nativeInfiniteScrollPost.length') &&
        !isAdvertorial(get(post, 'tags'))
      ) {
        this.setState(
          {
            finitePosts: [
              ...this.state.finitePosts,
              get(this.props, 'nativeInfiniteScrollPost[0]')
            ]
          },
          () => {
            this.renderedNativeInfiniteScrollPost = true;
          }
        );
      }
      this.setState({
        finitePosts: [...this.state.finitePosts, postFinite.shift()]
      });
    }
  }

  getInfiniteScrollAd(nativeType) {
    if (nativeType === 'nativeAdInfiniteScroll') {
      // console.log('get infinite scroll ad');
      const inifiniteAdData = get(window, 'fc_ads.native.infiniteScroll');
      if (inifiniteAdData) {
        // console.log('infinite ad data', inifiniteAdData);
        this.setState({ nativeInfiniteScrollData: inifiniteAdData });
      }
    }
  }

  getNative(nativeType) {
    if (nativeType === 'nativeMidArticleInject') {
      const nativeAdsDataMidArticleInject = get(
        window,
        'fc_ads.native.midArticleInject'
      );

      // console.log('get Native mid article inject', nativeAdsDataMidArticleInject, 'config', this.props.config);

      if (nativeAdsDataMidArticleInject) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataMidArticleInject,
          get(this.props, 'config')
        );
      }
    }

    if (nativeType === 'nativeAdSponsorTile') {
      const nativeAdsDataDianomi = get(window, 'fc_ads.native.dianomiTiles');

      if (nativeAdsDataDianomi) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataDianomi,
          get(this.props, 'config')
        );
      }
    }

    if (nativeType === 'nativeAdRecommendation') {
      const nativeAdsDataRecommendations = get(
        window,
        'fc_ads.native.recommendations'
      );

      if (nativeAdsDataRecommendations) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataRecommendations,
          get(this.props, 'config')
        );
      }
    }

    if (nativeType === 'nativeAdInfiniteScroll') {
      const nativeAdsDataInfiniteScroll = get(
        window,
        'fc_ads.native.infiniteScroll'
      );

      if (nativeAdsDataInfiniteScroll) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataInfiniteScroll,
          get(this.props, 'config')
        );
      }
    }

    return false;
  }

  setActive(postID) {
    this.state.activeInserts[postID] = 1;
    this.forceUpdate();
  }

  setInviewPostUrl(windowPosition, screenHeight) {
    if (!this.posts || !get(this.posts, 'length')) {
      return false;
    }

    const triggerPoint = windowPosition + screenHeight / 2;

    for (let i = 1; i <= get(this.posts, 'length'); i += 1) {
      const post = this.posts[i - 1];
      const sectionTopPosition = post.offsetTop;
      const sectionBottomPosition = sectionTopPosition + post.clientHeight;
      const postId = parseFloat(post.dataset.id);

      if (
        this.activePost !== postId &&
        sectionTopPosition <= triggerPoint &&
        sectionBottomPosition > triggerPoint
      ) {
        const postData =
          i === 1 ? this.props.post : this.state.finitePosts[i - 2];

        this.activePost = postData.id;

        // React router redux does not support replace state without page refresh.
        this.props.dispatchInfiniteScrollUrlChange();
        let replacedURL;
        if (postData.isNewUrl) {
          replacedURL = `/${postData.newUrl
            .split('/')
            .slice(-2)
            .join('/')}`;
        } else {
          replacedURL = `/${postData.id}/${postData.slug}`;
        }

        if (get(postData, 'isVideoPermalink')) {
          replacedURL = `/video/${postData.slug}/${get(
            postData,
            'posterVideo.feedId'
          )}`;
        }

        window.history.replaceState({}, '', replacedURL);

        // Only track this again on first post onwards
        if (i > 1 && this.trackedPosts.indexOf(this.activePost) === -1) {
          this.trackedPosts.push(this.activePost);
          this.refreshThirdPartyTrackers(postData, i);
        }

        this.setActiveSocial(post);
      }
    }
    return false;
  }

  loadPostFinite() {
    const postId = get(this.props, 'match.params.id');
    const config = get(this.props, 'config', {});
    const post = get(this.props, 'post', {});
    const postCategories = get(post, 'categories', []);
    const isMCPList = get(post, 'customFields.show_mcp_list', false);
    const isBWIList =
      get(post, 'customFields.select_the_list', false) === 'bwi2020';
    const isIBDList = find(get(post, 'tags'), {
      name: 'innovation by design 2020'
    });

    const advertorialTag = findAdvertorialTagID(get(post, 'tags'));
    const isReccomender = isCategory(postCategories, 'recommender');

    let override = '';

    if (isReccomender) {
      override = 'recommender';
    } else if (isMCPList) {
      override = 'mcp';
    } else if (isBWIList) {
      override = 'bwi';
    } else if (isIBDList) {
      override = 'ibd';
    }

    this.props.dispatchPostFinite(
      postId,
      advertorialTag,
      config,
      this.props.mic2020Companies,
      this.props.mic2020Regions,
      this.props.mic2020Sectors,
      override
    );
  }

  checkAdblock() {
    const { config } = this.props;
    const wordPressHome = get(config, 'wordPressHome');
    const apiEndpoint = get(config, 'apiEndpoint');
    const apiProtocol = get(config, 'protocol');

    if (document.getElementById('adblock-notice')) {
      axios
        .get(`${wordPressHome}/wp-json/wp/v2/posts?tags=21598`)
        .then(resp => {
          const article = get(resp, 'data[0]', {});
          if (article && article.id) {
            axios
              .get(
                `${apiProtocol}${apiEndpoint}/api/v3/post-related/fastcompany/${
                  article.id
                }`
              )
              .then(post => {
                this.setState(
                  {
                    finitePosts: [...this.state.finitePosts, post.data.post]
                  },
                  () => {
                    this.renderedNativeInfiniteScrollPost = true;
                    // console.log(this.state.finitePosts);
                  }
                );
              });
          }
        });
    }
  }

  refreshSocialEmbeds() {
    if (canUseDOM) {
      if (!window.instgrm) {
        scriptjs('//platform.instagram.com/en_US/embeds.js', () => {
          window.instgrm.Embeds.process();
        });
      } else {
        window.instgrm.Embeds.process();
      }

      scriptjs('//platform.twitter.com/widgets.js', () => {
        window.twttr.widgets.load();
      });
      // window.twttr.widgets.load();
      scriptjs('//view.ceros.com/scroll-proxy.min.js');
      scriptjs(
        '//creative-services.ceros.com/customer-success/varying-embed-tag-generator/embedded-variant-switcher-v3.min.js'
      );
    }
  }

  refreshThirdPartyTrackers(postData, pageNumber) {
    const { config } = this.props;
    const currentActivePostState = {
      context: {
        site: get(config, 'site'),
        type: 'post',
        postData
      },
      config
    };
    document.title = get(postData, 'title');
    trackThirdPartyJS(currentActivePostState, pageNumber);
  }

  generateAdData(postData) {
    const { config } = this.props;
    const site = get(config, 'site') || 'fastcompany';
    const adData = buildPostAdModel(adsConfig, site, postData, 'postPage');

    if (canUseDOM) {
      // Update the data layer
      extend(window.digitalData.page.pageInfo, {
        adPath: `/4160/mv.fc/${adData.model.adzone}`
      });
    }

    return extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') || {} },
      { definitions: get(adData, 'config.definitions') || {} },
      { model: adData.model || {} }
    );
  }

  renderDianomiOrMoreStories(combinedAdModel) {
    const { config, postAfterbodyRecircModuleType } = this.props;
    const initialPageLoad = get(config, 'initialPageLoad');
    const moduleType = get(postAfterbodyRecircModuleType, 'type');
    // const moduleType = 'dianomi';

    // If user is international, display dianomi regardless of options
    if (!initialPageLoad && canUseDOM) {
      if (Cookies.get('fc_rev_content')) {
        return (
          <Dianomi
            initialPageLoad={initialPageLoad}
            site={get(config, 'site')}
            postNativeAd={this.props.postNativeAd}
            config={config}
          />
        );
      }
    }

    // If type is more stories in manage, display that
    if (moduleType === 'More Stories') {
      return this.renderMoreStories(combinedAdModel);
    }

    // Default to dianomi
    return (
      <Dianomi
        initialPageLoad={initialPageLoad}
        site={get(config, 'site')}
        postNativeAd={this.props.postNativeAd}
        config={config}
      />
    );
  }

  renderVideo() {
    const { postVideo, config, post } = this.props;
    const feedID = get(post, 'posterVideo.feedId');
    const customparams = generateVideoCustomParams(post);

    // Do not display video module when on a video post
    if (feedID) {
      return '';
    }

    if (!isEmpty(postVideo)) {
      const currentSite = get(this.props, 'config.site');
      get(config, 'site');
      return (
        <VideoModule
          config={config}
          data={postVideo}
          playerid="MyQ2uJQ0"
          pos="newmultiplayer"
          stories={this.props.postVideo.playlist}
          currentSite={currentSite}
          isPost={true}
          readTime={get(post, 'readTime')}
          customparams={customparams}
        />
      );
    }

    return null;
  }

  renderMoreStories(combinedAdModel) {
    let postMoreStories = get(this.props, 'postMoreStories.posts');

    const { postAfterbodyRecircModuleType, config } = this.props;
    const postAfterbodyRecircModuleTiles = get(
      postAfterbodyRecircModuleType,
      'tiles'
    );
    const postAfterbodyRecircModuleTilesAdzoneMetadata = get(
      postAfterbodyRecircModuleType,
      'tileAdzone',
      ''
    );

    const postAfterbodyRecircModuleTilesAdzoneMetadataSplit = postAfterbodyRecircModuleTilesAdzoneMetadata.split(
      ','
    );
    let slugData;

    if (postAfterbodyRecircModuleTiles) {
      const currentDate = new Date();
      const isEvenDay = toNumber(currentDate.getDate()) % 2 === 0;

      postMoreStories = postAfterbodyRecircModuleTiles.map((story, idx) =>
        Object.assign(story, {
          id: `12345-${idx}`,
          currentSite: get(config, 'site'),
          events: false,
          assetSizes: imageSizesLookup.bigFirstMobile,
          noLazy: true,
          isSponsoredTile: isEvenDay,
          external: true
        })
      );

      slugData = {
        name: get(postAfterbodyRecircModuleTilesAdzoneMetadataSplit, '[1]'),
        tagLine: get(postAfterbodyRecircModuleTilesAdzoneMetadataSplit, '[2]')
      };
    }

    if (
      postMoreStories &&
      get(postMoreStories, 'length') &&
      get(this.props, 'postFinite.length') &&
      canUseDOM
    ) {
      return (
        <Fragment>
          {postAfterbodyRecircModuleTilesAdzoneMetadata ? (
            <Fragment>
              <Ad
                {...combinedAdModel}
                pos="btf"
                noBorder={true}
                slug={false}
                adzoneOverride={get(
                  postAfterbodyRecircModuleTilesAdzoneMetadataSplit,
                  '[0]'
                )}
                name="nativecollectionmodule_01"
              />
              <MoreStories
                metadata={postMoreStories}
                isPost={true}
                slugData={slugData}
                config={this.props.config}
                hasSponsoredContentLabel={true}
                noBottomBorder={true}
              />
            </Fragment>
          ) : (
            <MoreStories
              metadata={postMoreStories}
              isPost={true}
              config={this.props.config}
            />
          )}
        </Fragment>
      );
    }

    return null;
  }

  renderPostFinite(postFinite, related, sticky, config, playerIds) {
    if (!get(postFinite, 'length')) {
      return null;
    }

    return postFinite.map((postData, index) => {
      if (postData.isVideoPermalink || get(postData, 'posterVideo.feedId')) {
        if (!playerIds[index + 1]) {
          set(postData, 'playerScriptId', 'G2hQKLvX');
        } else {
          set(postData, 'playerScriptId', playerIds[index + 1]);
        }
      }

      const expandVal = postData.cardType
        ? this.state.nativeInfiniteScrollData.expanded
        : undefined;
      return (
        <Insert
          key={`insert_${index}`}
          expand={expandVal}
          config={config}
          tags={get(postData, 'tags')}
          postData={postData}
          insert={true}
          pageNum={index + 1}
          related={related}
          combinedAdModel={this.generateAdData(postData)}
          videoAdData={get(this.props.postpage, 'ads.model', {})}
          updateCorrelator={true}
          live={false}
          isDesktop={sticky}
          mic2020Companies={this.props.mic2020Companies}
          mic2020Regions={this.props.mic2020Regions}
          mic2020Sectors={this.props.mic2020Sectors}
          postPromoterArticleText={this.props.postPromoterArticleText}
        />
      );
    });
  }

  render() {
    const {
      config,
      statusCode,
      post,
      related,
      postpage,
      postPromoterArticleText
    } = this.props;
    const abGroupCookie = Cookies.get('abgroup');

    // const isNewUrl = get(this.props, 'match.params.isNewUrl', false);
    let defaultABGroup = 0;
    let shouldRenderVideoModule = true;
    let shouldRenderDianomi = true;

    if (abGroupCookie) {
      defaultABGroup = parseInt(abGroupCookie, 10);
    }

    // Groups 1-2: Hide all
    // Groups 3-20: No video/carousel
    //                       No newsletter signup
    //                       Only two Parsley "you might also like" links
    //                       Keep Dianomi

    if (
      (defaultABGroup >= 1 && defaultABGroup <= 2) ||
      isAdvertorial(get(post, 'tags'))
    ) {
      shouldRenderVideoModule = false;
      shouldRenderDianomi = false;
    }
    if (defaultABGroup >= 3 && defaultABGroup <= 20) {
      shouldRenderVideoModule = false;
    }

    const stickyToasterVideoDOM = this.state.stickToasterVideo ? (
      <FloatingPlayer
        floatingClassName="floating-player--is-floating"
        position="bottom-left-toaster"
        isFloating={this.state.stickToasterVideo}
      >
        <ToasterVideoModule
          config={this.props.config}
          unStick={() => {
            this.setState({
              stickToasterVideo: false,
              ignoreToasterVideo: true
            });
          }}
          type="toaster"
          playerid="2fyG0pBE"
          playlistId="PTvgvDm1"
          pos="toaster"
        />
      </FloatingPlayer>
    ) : (
      ''
    );
    if (postpage.isLoading && statusCode === 200) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    if (postpage.error || isEmpty(post)) {
      return (
        <section className="post-page">
          <article className="post__main--error-pg">
            <NotFound
              statusCode={statusCode}
              message={
                statusCode === 403 || statusCode === 401
                  ? 'Post is not available.'
                  : undefined
              }
            />
          </article>
        </section>
      );
    }

    const sticky = this.stickySidebar;
    const fullPageCeros = get(
      post,
      'customFields.full_page_ceros_embed',
      false
    );

    const combinedAdModel = this.generateAdData(post);
    if (post.isVideoPermalink || get(post, 'posterVideo.feedId')) {
      set(post, 'playerScriptId', this.playerScriptIds[0]);
    }

    return (
      <React.Fragment>
        <section className="post-page">
          {this.activePost && (
            <EditorHighlights activePostId={this.activePost} />
          )}
          {this.state.displayingAdhesiveUnit && (
            <div className="adhesive adhesive-banner">
              <Ad
                {...combinedAdModel}
                noBorder={true}
                slug={false}
                collapseEmptyDiv={true}
                name="mobile_adhesive"
              />
            </div>
          )}
          {/*
          <div className="homepage-mobile__featured-covid">
            UPDATES: <a href="/section/coronavirus">COVID-19</a>
          </div>
          */}
          <PostsContainer
            config={this.props.config}
            posts={[post]}
            combinedAdModel={combinedAdModel}
            pageNum={0}
            related={related}
            isDesktop={sticky}
            isFirstPost={true}
            videoAdData={get(postpage, 'ads.model', {})}
            live={this.live}
            mic2020Companies={this.props.mic2020Companies}
            mic2020Regions={this.props.mic2020Regions}
            mic2020Sectors={this.props.mic2020Sectors}
            postPromoterArticleText={postPromoterArticleText}
          />

          {stickyToasterVideoDOM}
          {this.live || this.noscroll ? (
            <div className="post__article-top-ad-wrapper">
              <Ad
                {...combinedAdModel}
                name="flexiblebillboard"
                region="articlebottom"
                pageNum={1}
              />
              <Ad
                {...combinedAdModel}
                name="mobileleaderboard"
                region="articlebottom"
                pageNum={1}
              />
            </div>
          ) : (
            <div>
              {!fullPageCeros && shouldRenderDianomi
                ? this.renderDianomiOrMoreStories(combinedAdModel)
                : ''}
              {shouldRenderVideoModule ? this.renderVideo() : ''}
              {this.renderPostFinite(
                this.state.finitePosts,
                related,
                sticky,
                config,
                this.playerScriptIds
              )}
            </div>
          )}
        </section>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    adsLoaded: get(state, 'ads.data'),
    statusCode: get(state, 'status.code'),
    config: state.config,
    postpage: state.postpage,
    post: get(state, 'post.data.post', {}),
    related: get(state, 'post.data.related', []),
    postVideo: get(state, 'postVideo.data', {
      feedid: '',
      playlist: [],
      title: ''
    }),
    postAfterbodyRecircModuleType: get(
      state,
      'postAfterbodyRecircModuleType.data'
    ),
    postPromoterArticleText: get(state, 'postPromoterArticleText.data.text'),
    postMoreStories: get(state, 'postMoreStories.data'),
    postFinite: get(state, 'postFinite.data.posts', []),
    postNativeAd: get(state, 'postNativeAd.data', {}),
    nativeInfiniteScrollPost: get(
      state,
      'postNativeAd.data.infiniteScroll.posts',
      []
    ),
    mic2020Companies: get(state, 'mic2020Companies.companies', []),
    mic2020Regions: get(state, 'mic2020Regions.regions', []),
    mic2020Sectors: get(state, 'mic2020Sectors.sectors', [])
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchInfiniteScrollUrlChange() {
      dispatch(infiniteScrollUrlChange());
    },

    dispatchPostFinite(
      id,
      advertorialTag,
      config,
      companies,
      regions,
      sectors,
      override
    ) {
      return asyncPostFiniteActions(
        dispatch,
        id,
        advertorialTag,
        config,
        companies,
        regions,
        sectors,
        override
      );
    },

    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

PostPage.defaultProps = {
  postAfterbodyRecircModuleType: {
    type: 'More Stories'
  },
  postPromoterArticleText: '',
  mic2020Companies: [],
  mic2020Regions: [],
  mic2020Sectors: []
};

PostPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  config: PropTypes.shape({}).isRequired,
  dispatchInfiniteScrollUrlChange: PropTypes.func.isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired,
  dispatchPostFinite: PropTypes.func.isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  post: PropTypes.shape({
    id: PropTypes.number,
    customFields: PropTypes.shape({
      is_list: PropTypes.bool
    })
  }).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postpage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    postScrollDepth: PropTypes.number
  }).isRequired,
  postVideo: PropTypes.shape({
    feedid: PropTypes.string,
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string
  }).isRequired,
  postFinite: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postNativeAd: PropTypes.shape({}).isRequired,
  postAfterbodyRecircModuleType: PropTypes.shape({
    type: PropTypes.string
  }),
  postPromoterArticleText: PropTypes.string,
  trackEvent: PropTypes.func.isRequired,
  mic2020Companies: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Regions: PropTypes.arrayOf(PropTypes.shape()),
  mic2020Sectors: PropTypes.arrayOf(PropTypes.shape())
};

const mapTrackingToProps = trackEvent => ({
  trackEvent: pageObject => trackEvent(defaultEvent(pageObject))
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withTracking(mapTrackingToProps)(PostPage)
);
